/**
 * 表单控件类别
 */
export enum AppPageElementType {
    /**
     * 文本框
     */
    Text = 0,
    /**
    * 数字控件
    */
    Number = 1,
    /**
    * 座机号码
    */
    Tel = 2,
    /**
    * 手机号码
    */
    Phone = 3,
    /**
    * 邮箱控件
    */
    Email = 4,
    /**
    * 多选/单选
    */
    Checkbox = 5,
    /**
    * 多行文本
    */
    Textarea = 6,
    /**
    * 文件上传
    */
    File = 7,
    /**
    * 下拉框
    */
    Select = 8,
    /**
    * 日期时间类型
    */
    DateTime = 9,
    /**
    * 图表控件
    */
    highcharts = 10,
    /**
    * 上传控件
    */
    Pic = 11,
    /**
    * 放大镜
    */
    GridPicker = 12,
    /**
    * 是否可选
    */
    Toggle = 13,
    /**
    * 提交按钮
    */
    Button = 14,
    /**
    * 定位控件
    */
    location = 15,
    /**
    * 扫描二维码
    */
    scanner = 16,
    /**
    * 隐藏控件
    */
    Hidden = 17,
    /**
    * 图片
    */
    Img = 18,
    /**
    * url
    */
    Url = 19,
    /**
    ///密码
    */
    Password = 20,
    /**
    * 地区选择
    */
    Area = 21,
    /**
    * 时间段
    */
    TimeSlot = 22,
    /**
    * null
    */
    Null = 23,
    /**
    *数量显示面板
    */
    Count = 24,
    /**
    * 搜索框
    */
    SearchBar = 25,
    /**
    * 显示文本
    */
    Title = 26,
    /**
    * 显示文本（和Title使用标签不同）
    */
    Label = 27,
    /**
    * 列表
    */
    Grid = 28,
    /**
    * Link
    */
    Link = 29,
    /**
    * 表格
    */
    Table = 30,
    /**
    * 表格
    */
    Radio = 31,
    /**
     * 主明细
     */
    Autocomplete = 32
}